import { render, staticRenderFns } from "./dictList.vue?vue&type=template&id=8072302c&scoped=true"
import script from "./dictList.vue?vue&type=script&lang=js"
export * from "./dictList.vue?vue&type=script&lang=js"
import style0 from "./dictList.vue?vue&type=style&index=0&id=8072302c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8072302c",
  null
  
)

export default component.exports